import React, { useState } from 'react';
import {updateRequest} from '../../firebase';

export default function ConnectModal({modalDetails}) {
    const [name,setName]=useState("");
    const [phone,setPhone]=useState("");
    const [load,setLoad]=useState(false);
    const [msg,setMsg]=useState("");

    const sendConnect = () =>{
        setLoad(true);
        updateRequest(modalDetails.id,{
            reqId:Date.now().toString(),
            typeId:modalDetails.typeId,
            typeName: modalDetails.type,
            userId:modalDetails.id,
            name: name,
            contact:phone
        }).then(res=>{
            setLoad(false);
            setMsg("Connected");
        }).catch(err => {
            setLoad(false);
            setMsg("Failed");
        })
    }

    return (
        <div className="modal fade" id="connectModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Connect</h5>
                        <div type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="row text-align-center gy-2">
                        <div className="form-group col-md-12">
                                <input type="text" name="name" className="form-control form-control-sm"
                                     id="name" placeholder="Name"
                                     value={name} onChange={(e)=>setName(e.target.value)} required />
                            </div>
                            <div className="form-group col-md-12">
                                <input type="number" name="phone" className="form-control form-control-sm"
                                     id="phone" placeholder="Mobile number"
                                     value={phone} onChange={(e)=>setPhone(e.target.value)} required />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        {msg && <i className="h6">{msg}</i>}
                        <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-sm btn-warning"
                        disabled={!name || !phone || load}
                        onClick={()=>sendConnect()}>{load?"Wait":"Send"}</button>
                    </div>
                </div>
            </div>
        </div>

    )
}
